import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import { useCallback, useState } from 'react';

import { useUpdateAvatar } from '../../hooks/useProfile';
import { getImageUrl } from '../../lib/getImageSize';

import LoadingIcon from '../icons/LoadingIcon';
import UploadModal from '../popups/UploadModal';
import BasicButton from './BasicButton';

import styles from '../../styles/buttons/avatar-button.module.css';

import { ReactComponent as CameraIcon } from '../../assets/img/icons/camera.svg';

interface AvatarButtonProps {
    className?: string | null;
}

function AvatarButton({ className }: AvatarButtonProps) {
    const [opened, setOpened] = useState(false);
    const { updateAvatarAsync, isPending: loading = false } = useUpdateAvatar();
    const { avatar = null, name = null, firstname = null, lastname = null } = useUser() || {};
    const finalName = name ?? [firstname, lastname].filter((it) => it !== null).join(' ');
    const initials =
        finalName !== null && finalName !== ''
            ? finalName
                  .split(' ')
                  .reduce((map, n) => [...map, ...n.split('-')], [])
                  .map((n) => n[0])
                  .join('')
            : null;
    const url = getImageUrl(avatar, 'thumbnail');
    const onClickButton = useCallback(() => {
        setOpened(true);
    }, []);
    const onCancel = useCallback(() => {
        setOpened(false);
    }, []);
    const onComplete = useCallback((newFile) => {
        const { uploadURL } = newFile;
        updateAvatarAsync(uploadURL).then(() => {
            setOpened(false);
        });
    }, []);
    return (
        <>
            <BasicButton
                className={classNames([
                    styles.container,
                    {
                        [styles.withAvatar]: url !== null,
                    },
                    className,
                ])}
                onClick={onClickButton}
            >
                <span className={styles.shape}>
                    {url !== null ? (
                        <img src={url} className={styles.image} />
                    ) : (
                        <span className={styles.initials}>{initials}</span>
                    )}
                    <span className={styles.bottom}>
                        <CameraIcon />
                    </span>
                    {loading ? <LoadingIcon className={styles.loading} /> : null}
                </span>
            </BasicButton>
            {opened ? <UploadModal onCancel={onCancel} onComplete={onComplete} /> : null}
        </>
    );
}

export default AvatarButton;
